import useNavigation from './useNavigation';

export default function useLogoutNavigation() {
  return useNavigation('/logout');
}
